import { PoMicroFrontend } from 'micro-frontend.react';
import { renderV2 } from 'base/wrapped-render-v2';

interface NonEmployeeUserModalUser {
    userId?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
}

interface NonEmployeeUserModalAccessLevel {
    id: string;
    type: string;
    name: string;
}

interface NonEmployeeUserModalProps {
    accessLevel: NonEmployeeUserModalAccessLevel;
    onSubmitCallback: () => void;
    user?: NonEmployeeUserModalUser;
}

export const openNonEmployeeUserModal = ({
    accessLevel,
    onSubmitCallback,
    user,
}: NonEmployeeUserModalProps) => {
        const rootElement = document.createElement('div');
        document.body.appendChild(rootElement);

        renderV2({
            children: (
                <PoMicroFrontend
                    accessLevel={accessLevel}
                    onSubmitCallback={onSubmitCallback}
                    route="/access-levels/non-employee-user-modal"
                    user={user}
                />
            ),
            attachedElement: rootElement
        });
};
